import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2
} from "@angular/core";

@Directive({
  selector: "[taFileDrop]"
})
export class FileDropDirective {
  @Input() acceptedExtensions: string[] = [];
  @Input() limitOne: boolean = false;

  @Output() fileChange: EventEmitter<File[]> = new EventEmitter();
  @Output() invalidDrop: EventEmitter<string> = new EventEmitter();

  @HostListener("drop", ["$event"])
  onDrop(event: DragEvent): void {
    if (!event.dataTransfer) {
      return;
    }
    event.preventDefault();
    this.renderer.removeClass(this.element.nativeElement, "drop-hover");
    const files: FileList = event.dataTransfer.files;
    if (this.violatesLimit(files)) {
      this.invalidDrop.emit("Only one file may be dropped");
      return;
    }
    if (this.violatesAcceptedExtensions(files)) {
      this.invalidDrop.emit(
        "Unacceptable file extension. Please use " +
          this.acceptedExtensions.map((ext) => ext.toUpperCase()).join("/") +
          "."
      );
      return;
    }
    this.fileChange.emit(Array.from(files));
  }

  @HostListener("dragover", ["$event"])
  @HostListener("dragenter", ["$event"])
  onDrag(event: DragEvent): void {
    if (!event.dataTransfer) {
      return;
    }
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
    this.renderer.addClass(this.element.nativeElement, "drop-hover");
  }

  @HostListener("dragleave", ["$event"])
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.renderer.removeClass(this.element.nativeElement, "drop-hover");
  }

  constructor(private element: ElementRef, private renderer: Renderer2) {}

  private violatesLimit(items: FileList): boolean {
    return this.limitOne && items.length > 1;
  }

  private violatesAcceptedExtensions(items: FileList): boolean {
    return this.acceptedExtensions.length === 0
      ? false
      : Array.from(items).some((item) => {
          return !this.acceptedExtensions.some((extension) =>
            item.type.includes(extension)
          );
        });
  }
}
